package com.cs.ejobin.data.supabase

import com.cs.ejobin.data.ExtrasRepository
import com.cs.ejobin.data.supabase.dto.ProfileRow
import com.cs.ejobin.model.Extra
import com.cs.ejobin.model.Skill
import io.github.jan.supabase.SupabaseClient
import io.github.jan.supabase.postgrest.from
import io.github.jan.supabase.postgrest.query.Order

class SupabaseExtrasRepository(
    private val supabase: SupabaseClient
) : ExtrasRepository {

    override suspend fun listExtras(query: String, skillFilters: Set<String>): List<Extra> {
        return listExtrasPaged(
            query = query,
            skillFilters = skillFilters,
            limit = 200,
            offset = 0
        )
    }

    suspend fun listExtrasPaged(
        query: String,
        skillFilters: Set<String>,
        limit: Int,
        offset: Int
    ): List<Extra> {
        val q = query.trim()

        val rows = supabase.from("profiles")
            .select {
                range(offset.toLong()..(offset + limit - 1).toLong())

                order("name", order = Order.ASCENDING)

                filter {
                    if (q.isNotEmpty()) {
                        ilike("name", "%$q%")
                    }
                    if (skillFilters.isNotEmpty()) {
                        contains("skills", skillFilters.toList())
                    }
                }
            }
            .decodeList<ProfileRow>()

        return rows.map { it.toExtra() }
    }

    override suspend fun getExtra(extraId: String): Extra {
        val row = supabase.from("profiles")
            .select { filter { eq("id", extraId) } }
            .decodeSingle<ProfileRow>()

        return row.toExtra()
    }
}

private fun ProfileRow.toExtra(): Extra =
    Extra(
        id = id,
        name = name,
        phone = phone,
        isAvailable = isAvailable,
        photoUrl = photoUrl,
        skills = skills.mapIndexed { idx, s -> Skill("db$idx", s) },
        description = description
    )